import { RsoCreatePage } from "@/features/rso/pages/RsoCreate";
import React from "react";

const RsoCreate = () => {
  return <RsoCreatePage />;
};

export default RsoCreate;
